var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmployeeAdminTable',{attrs:{"items":_vm.items,"is-busy":_vm.isBusyStore,"pagination":_vm.pagination,"is-super-admin":_vm.isSuperAdmin},on:{"changePage":_vm.handlePageChange,"assign":_vm.assignEmployeeAdmin,"delete":_vm.deleteEmployeeAdmin,"transfer":_vm.transferSuperAdmin}})
}
var staticRenderFns = []

export { render, staticRenderFns }